export default {
  locale: localStorage.locale || "en",
  currency: localStorage.currency || "EUR",
};
